module.exports = __webpack_public_path__ + "img/logo-prac.00907fe0.svg";